import { Component } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ITableResponsive } from 'src/app/domain/ITableResponsive';
import { MessagesEnum } from 'src/app/domain/enums/messages.enum';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { TypeIndexEnum } from 'src/app/domain/registration/enums/type-index.enum';
import { IDownload } from 'src/app/domain/registration/models/IDownload';
import { AbstractCrudIndex } from 'src/app/shared/components/crud/abstract-crud-index';
import { GlobalUtils } from 'src/app/shared/global-utils';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { DownloadCESComponent } from '../crud-ces/crud-ces.component';
import {
  COLUMNS_TO_SHOW_MOBILE,
  COLUMNS_TO_SHOW_WEB,
  TABLE_CONFIG_COLUMNS,
} from '../crud-config';
import { DownloadService } from '../crud-service';
import { getSystemTypeDescriptionByValue } from 'src/app/domain/registration/enums/system-type.enum';
import moment from 'moment';
import { take } from 'rxjs';
import { DialogConfirmComponent } from 'src/app/shared/components/dialog-confirm/dialog-confirm.component';
import { FileDescriptionComponent } from '../file-description/file-description.component';
import { FormDataCreateDownloads } from '../crud-ces/formDataBuild/form-data-create';
import { S3_URL_BASE } from 'src/environments/environment';
import { FileViewerDialogComponent } from '../../trainings/file-viewer-dialog/file-viewer-dialog.component';
import { ChangeDetectorRef } from '@angular/core';
import { DownloadProgressDialogComponent } from '../download-progress-dialog-component/download-progress-dialog-component.component';
import { AuthService } from 'src/app/views/auth/shared/auth.service';
import { PasswordDialogComponent } from '../../password-dialog/password-dialog.component';
import { PermissionService } from 'src/app/shared/permission.service';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';

@Component({
  selector: 'app-download-index',
  templateUrl: './crud-index.component.html',
  styleUrls: ['./crud-index.component.sass'],
  providers: [DownloadService],
})
export class DownloadCrudIndex
  extends AbstractCrudIndex<IDownload>
  implements ITableResponsive
{
  override title = 'SOLUÇÕES';
  override displayedColumns = COLUMNS_TO_SHOW_WEB;
  override configColumns = TABLE_CONFIG_COLUMNS;

  loadingDownloads: { [key: string]: boolean } = {};
  loadingProgress: { [key: string]: number } = {};
  currentRequest: XMLHttpRequest | null = null;

  currentTab: string = 'downloads'; 
  userType: string = 'admin'; 
  public filterFormValues: any = null
  constructor(
    public override dialog: MatDialog,
    public override service: DownloadService,
    public override toastService: ToastService,
    public override mediaObserver: MediaObserver,
    public override router: Router,
    protected cdr: ChangeDetectorRef,
    protected authService: AuthService, 
    public permissionService: PermissionService,
  ) {
    super(dialog, service, toastService, mediaObserver, router);
  
    
    this.userType = this.authService.isPartner() ? 'partner' : 'admin';
    this.currentTab = 'downloads';
  
    mediaObserver.asObservable().subscribe((res) => {
      this.is_mobile = res[0].mqAlias === 'sm' || res[0].mqAlias === 'xs';
      this.displayedColumns = this.is_mobile
        ? COLUMNS_TO_SHOW_MOBILE
        : COLUMNS_TO_SHOW_WEB;
    });
  }
  
  private formatFileSize(size: number): string {
    if (size >= 1024 * 1024) {
      return (size / (1024 * 1024)).toFixed(2) + ' MB';
    } else if (size >= 1024) {
      return (size / 1024).toFixed(2) + ' KB';
    } else {
      return size + ' B';
    }
  }

  ngAfterViewInit(): void {
    this.loadList();
  }

  override loadList() {
    let params = this.params;

    this.service.listAll(params).subscribe((dataWithPagination: any) => {
      const [data, length] = dataWithPagination;
      this.length = length;
      
      this.dataSource = this.getDataSource(data);
      
    });
  }

  public getDataSource(data: any): MatTableDataSource<any> {
    return new MatTableDataSource<any>(
      data.map((item: any) => {
        item['type'] = getSystemTypeDescriptionByValue(item.type);
        item['image'] = item.system?.image;
        item['system'] = item.system || 'Solução não definida';
        item['systemName'] = item.system?.name || 'Solução não definida';
        item['createdAt'] = moment(item.createdAt).format('DD/MM/YYYY HH:mm');
        item['fileType'] = item.fileType || 'Tipo de arquivo não definido';
        item['systemVersion'] = item.systemVersion || 'Versão da solução não definida';
        item['fileAttachment'] = item.fileAttachment;
        item['fileSize'] = this.formatFileSize(item.fileSize); 
        item['hideEdit'] = !item.allowEdit;
        item['hideDelete'] = !item.allowDelete;
        console.log(item);
        return item;
      })
    );

  }

  openShow(element: any) {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      dialogConfig: { width: '75%' },
      component: DownloadCESComponent,
      data: { type: TypeCesEnum.SHOW, element },
      callBack: (data: any) => {
        if (data?.changeType === TypeCesEnum.EDIT) {
          this.openEdit(element);
        }

        if (data?.result) {
          this.openDelete(element);
        }
      },
    });
  }
  openNew(event: any) {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      dialogConfig: { width: '75%' },
      component: DownloadCESComponent,
      data: { type: TypeCesEnum.NEW, element: null },
      callBack: async (data: any) => {
        if (data?.element) {
          const name = data.element.name ? data.element.name.toUpperCase() : '';
          const dueDate = data.element.dueDate ? data.element.dueDate : null;
  
          this.service
            .createWithFormData(
              await new FormDataCreateDownloads().build({
                ...data.element,
                name,
                dueDate,
              })
            )
            .subscribe(
              (response: any) => {
                this.loadList();
                this.toastService.showSuccess(MessagesEnum.SUCCESS_CREATED_DOWNLOAD);
              },
              (error) => {
                this.toastService.showError(MessagesEnum.ERROR_TO_CREATE);
                this.openNew(data.element);
              }
            );
        }
      },
    });
  }
  
  openEdit(element: any) {
  GlobalUtils.openDialog({
    dialog: this.dialog,
    dialogConfig: { width: '75%' },
    component: DownloadCESComponent,
    data: { type: TypeCesEnum.EDIT, element },
    callBack: async (data: any) => {
      if (data?.element?.id) {
        const name = data.element.name ? data.element.name.toUpperCase() : '';
        const dueDate = data.element.dueDate ? data.element.dueDate : null;

        this.service
          .updateWithFormData(
            data.element.id,
            await new FormDataCreateDownloads().build({
              ...data.element,
              name,
              dueDate,
              // partner,
            })
          )
          .subscribe({
            next: () => {
              this.loadList();
              this.toastService.showSuccess(MessagesEnum.SUCCESS_UPDATED_DOWNLOAD);
            },
            error: (error) => {
              this.openEdit(data.element);
            },
          });
      }

      if (data?.changeType === TypeCesEnum.SHOW) {
        this.openShow(element);
      }

      if (data?.result) {
        this.openDelete(element);
      }
    },
  });
}

  
handlePlay(element: any) {
  const fileAttachment = element.fileAttachment;
  if (fileAttachment) {
    const fileExtension = fileAttachment.split('.').pop()?.toLowerCase();
    if (['mp4', 'jpg', 'png', 'pdf', 'mkv'].includes(fileExtension)) {
      // Se for um arquivo .mp4, .jpg, .png ou .pdf, abre o modal
      const completeUrl = S3_URL_BASE + fileAttachment;
      this.dialog.open(FileViewerDialogComponent, {
      data: {fileUrl : completeUrl, onlyLink: true},
      width: '80%',
      height: '80%'
      });
    } else {
      // Caso contrário, exibe a mensagem de erro
      this.toastService.showError('O arquivo selecionado não é suportado para visualização.');
    }
  } else {
    this.toastService.showError('Arquivo não encontrado.');
  }
}

downloadFile({ fileUrl, element }: { fileUrl: string; element: any }): void {
  if (fileUrl) {
    const completeUrl = S3_URL_BASE + fileUrl;
    console.log('Tentando baixar o arquivo a partir da URL:', completeUrl);

    this.loadingDownloads[element.id] = true;
    this.loadingProgress[element.id] = 0;

    const xhr = new XMLHttpRequest();
    this.currentRequest = xhr; 

    const dialogRef = this.dialog.open(DownloadProgressDialogComponent, {
      disableClose: true,
      width: '400px',
      data: { progress: 0 },
    });
    
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'cancel') {
        this.cancelDownload(element);
      } else if (result === 'close') {
        this.toastService.showInfo('O modal foi fechado, mas o download continuará em segundo plano.');
      }
    });

    xhr.open('GET', completeUrl, true);
    xhr.responseType = 'blob';

    xhr.onprogress = (event) => {
      if (event.lengthComputable) {
        const progress = Math.round((event.loaded / event.total) * 100);
        this.loadingProgress[element.id] = progress;
        dialogRef.componentInstance.updateProgress(progress);
      }
    };

    xhr.onload = () => {
      if (xhr.status === 200) {
        const blob = xhr.response;
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.getFileNameFromUrl(fileUrl));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        this.toastService.showError('Falha ao baixar o arquivo.');
      }
    };

    xhr.onerror = () => {
      this.toastService.showError('Erro ao baixar o arquivo.');
    };

    xhr.onloadend = () => {
      this.loadingDownloads[element.id] = false;
      this.loadingProgress[element.id] = 0;
      this.currentRequest = null; 
      dialogRef.close();
    };

    xhr.send();
  } else {
    this.toastService.showError('Arquivo não encontrado.');
  }
}


cancelDownload(element: any): void {
  if (this.currentRequest) {
    this.currentRequest.abort();
    this.toastService.showInfo(`Download cancelado para o arquivo: ${element.fileAttachment}`);
    this.loadingDownloads[element.id] = false;
    this.loadingProgress[element.id] = 0;
    this.currentRequest = null;
  }
}

  showDescriptionFile(element: any): void {
    console.log('Elemento:', element); 
    const dialogRef = this.dialog.open(FileDescriptionComponent, {
      width: '40%',
      data: element 

    });
  
    dialogRef.afterClosed().subscribe(result => {
      console.log('O modal foi fechado');
    });
  }
  
  private getFileNameFromUrl(url: string): string {
    return url.substring(url.lastIndexOf('/') + 1); 
  }

  public lock(download: any) {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      data: { title: `Bloquear download => sistema: ${download.system}, terminais: ${download.terminalQuantity}` },
      component: DialogConfirmComponent,
      callBack: (data: any) => {
        if (data?.result) {
          this.service
            .changeActiveStatus(download.id!, false)
            .pipe(take(1))
            .subscribe({
              next: () => {
                this.toastService.showSuccess(MessagesEnum.PLAN_LOCK_SUCCESS);
                this.loadList();
              },
              error: (e) => console.log(e),
            });
        }
      },
    });
  }

  public unlock(download: any) {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      data: { title: `Desbloquear download => sistema: ${download.name}, terminais: ${download.terminalQuantity}` },
      component: DialogConfirmComponent,
      callBack: (data: any) => {
        if (data?.result) {
          this.service
            .changeActiveStatus(download.id!, true)
            .pipe(take(1))
            .subscribe({
              next: () => {
                this.toastService.showSuccess(
                  MessagesEnum.PLAN_UNLOCK_SUCCESS
                );
                this.loadList();
              },
              error: (e) => console.log(e),
            });
        }
      },
    });
  }

  public resetFilter(): void {
    this.filterFormValues = null;
    localStorage.removeItem('parcllilterFormValues');

    this.isAdvancedFilterActive = false;
    this.lastAppliedFilter = null;
    this.params = { limit: 25, page: 0, filter: '' };

    const resetFields = this.filterFields.map(field => {
      if (field.type === TypeComponentFieldEnum.SLIDE_TOGGLE) {
        return { ...field, value: false };
      }
      return { ...field, value: '' };
    });

    this.filterFields = resetFields;

    this.loadList();
  }
}
